import { useQuery } from "@tanstack/react-query";
import { isLocalLoginAllowed } from "services";

export const useIsLocalLoginAllowed = () => {
    return useQuery({
        queryKey: ["isLocalLoginAllowed"],
        queryFn: isLocalLoginAllowed,
        select: response => response.data,
        staleTime: 5 * 60 * 1000,
    });
};
